<script>
import {Line} from 'vue-chartjs'

export default {
  extends: Line,
  props: ['envData'],
  computed: {
    chartData: function() {
      return {
        labels: this.labels,
        datasets: [
          {
            type: 'line',
            label: this.$t('Analysis.max_temp'),
            borderColor: '#CC3300',
            backgroundColor: '#CC3300',
            borderWidth: 1,
            pointRadius: 3,
            pointHoverRadius: 5,
            showLine: true,
            fill: false,
            data: this.countsForEnv('max_temp'),
            yAxisID: 'line-1'
          },
          {
            type: 'line',
            label: this.$t('Analysis.min_temp'),
            borderColor: '#B2E1F6',
            backgroundColor: '#B2E1F6',
            borderWidth: 1,
            pointRadius: 3,
            pointHoverRadius: 5,
            showLine: true,
            fill: false,
            data: this.countsForEnv('min_temp'),
            yAxisID: 'line-1'
          },
          {
            type: 'line',
            label: this.$t('Cuona.Device.humidity'),
            borderColor: '#24AAE6',
            backgroundColor: '#24AAE6',
            borderWidth: 1,
            pointRadius: 3,
            pointHoverRadius: 5,
            showLine: true,
            fill: false,
            data: this.countsForEnv('avg_hum'),
            yAxisID: 'line-2'
          },
          {
            type: 'line',
            label: this.$t('Cuona.Device.pressure'),
            borderColor: '#999999',
            backgroundColor: '#999999',
            borderWidth: 1,
            pointRadius: 3,
            pointHoverRadius: 5,
            showLine: true,
            fill: false,
            data: this.countsForEnv('avg_pres'),
            yAxisID: 'line-3'
          }
        ]
      }
    },
    labels: function() {
      return Object.keys(this.envData).sort();
    }
  },
  mounted() {
    let obj = this;
    this.options = {
      legend: {
        position: "bottom"
      },
      // onClick: function(evt, item){
      //   console.log(item)
      //   if(item[0] != undefined){
      //     var date = item[2]['_model'].label
      //     date = date.replace(/\//g, "")
      //     obj.$emit('changeGraph', date)
      //   }
      // },
      tooltips: {
        mode: 'x-axis',
        intersect: false,
        position: 'nearest'
      },
      hover: {
        mode: 'x-axis',
        intersect: false
      },
      scales: {
        xAxes: [{
          stacked: false,
          gridLines: {
            display: true
          },
          ticks: {
            fontColor: "#999",
            // callback: function(value, index, values){
            //   return value.replace(/20[0-9]{2}\//g, "")
            // }
          }
        }],
        yAxes: [{
          id: 'line-1',
          stacked: false,
          ticks: {
            min: -10,
            max: 50,
            fontColor: "#999"
          },
          gridLines: {
            drawOnChartArea: false,
          },
          scaleLabel: {
            display: true,
            labelString: this.$t('Cuona.Device.temperature'),
            fontSize: 12,
            position: 'top'
          }
        },
        {
          id: 'line-2',
          stacked: false,
          position: "right",
          ticks: {
            min: 0,
            max: 100,
            fontColor: "#999"
          },
          gridLines: {
            drawOnChartArea: false,
          },
          scaleLabel: {
            display: true,
            labelString: this.$t('Cuona.Device.humidity'),
            fontSize: 12
          }
        },
        {
          id: 'line-3',
          stacked: false,
          position: "right",
          ticks: {
            min: 950,
            max: 1050,
            fontColor: "#999"
          },
          gridLines: {
            drawOnChartArea: false,
          },
          scaleLabel: {
            display: true,
            labelString: this.$t('Cuona.Device.pressure'),
            fontSize: 12
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      spanGaps: true,
      elements: {
        line: {
          tension: 0
        }
      },
      plugins: {
        datalabels: {
          display: true,
          align: 'end',
          font: {
            size: 11
          },
          color: function(context) {
            return context.dataset.backgroundColor;
          },
          formatter: function(value, context) {
            return Math.round(value);
          }
        }
      }
    };
    this.renderChart(this.chartData,this.options);
  },
  methods: {
    countsForEnv: function(element) {
      return this.labels.map(date => Math.round((this.envData[date] && this.envData[date][element])*100)/100 || null);
    }
  },
  watch : {
    envData: function() {
      this.renderChart(this.chartData, this.options)
    }
  }
}
</script>
